import React, { FC, Fragment, ReactNode, useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { RootState, useSelector } from 'src/store';
// import echo from 'src/hooks/echo';
import { User } from 'src/models/user';

export interface AuthenticatedProps {
    children: ReactNode;
}

const ProviderUser: FC<AuthenticatedProps> = (props: { children: any }) => {
    const { children } = props;
    const { onUpdateUser } = useAuth();
    const {
        isLoading
    } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState<string | null>(
        null
    );

    useEffect(() => {
        if (isLoading == null) {
            onUpdateUser(null);
        }
    }, [isLoading])



    const launch = () => {
        if (requestedLocation && location.pathname !== requestedLocation) {
            setRequestedLocation(null);
            return <Navigate to={requestedLocation} />;
        } else {
            return <>{children}</>;
        }
    }

    return <Fragment>{isLoading === false && launch()}</Fragment>;
}
    ;

ProviderUser.propTypes = {
    children: PropTypes.node
};

export default ProviderUser;
